export const NARRATION_TRANSCRIPT_STORAGE_KEY = "whisperverse.showNarrationInTranscript.v1";

export function parseNarrationTranscriptPreference(value: string | null) {
  return value === "true";
}

export function serializeNarrationTranscriptPreference(value: boolean) {
  return value ? "true" : "false";
}
